import { render } from "./COICoreItem.vue?vue&type=template&id=bfeb121c&scoped=true"
import script from "./COICoreItem.vue?vue&type=script&lang=js"
export * from "./COICoreItem.vue?vue&type=script&lang=js"

import "./COICoreItem.vue?vue&type=style&index=0&id=bfeb121c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfeb121c"]])

export default __exports__